//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'page-textarea',
  methods: {
    handleChange(val){
      console.log(val)
    }
  }
};



// WEBPACK FOOTER //
// ./example/pages/textarea.vue